import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from "react";
export function GrantListItemContainer(t0) {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <li className="tw-list-none tw-py-6 tw-px-6">{children}</li>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}